export const DEFAULT_FEES_REGION = "US";
export const SHIPPING_METHODS = {
  US: ["air"],
  CN: ["marine"],
  JP: ["air"],
  DE: ["air"],
};

export function normalizeFeesRegion(rawRegion) {
  const region = String(rawRegion || "").toUpperCase();
  return SHIPPING_METHODS[region] ? region : DEFAULT_FEES_REGION;
}

export function normalizeFeesMethod(rawRegion, rawMethod) {
  const region = normalizeFeesRegion(rawRegion);
  const allowedMethods =
    SHIPPING_METHODS[region] || SHIPPING_METHODS[DEFAULT_FEES_REGION];
  const method = String(rawMethod || "").toLowerCase();
  return allowedMethods.includes(method) ? method : allowedMethods[0];
}

export function normalizeFeesRoute(rawRegion, rawMethod) {
  const region = normalizeFeesRegion(rawRegion);
  return {
    region,
    method: normalizeFeesMethod(region, rawMethod),
  };
}

export function buildFeesPath(region, method) {
  const normalized = normalizeFeesRoute(region, method);
  return `/fees/${normalized.region}/${normalized.method}`;
}

export function getCanonicalFeesLocation(route = {}) {
  const params = route.params || {};
  const query = route.query || {};
  const currentPath = String(route.path || "");
  const { region, method } = normalizeFeesRoute(
    params.region || query.region,
    params.method || query.method
  );
  const path = buildFeesPath(region, method);
  const nextQuery = { ...query };

  delete nextQuery.region;
  delete nextQuery.method;

  const hasLegacyRegionQuery = Object.prototype.hasOwnProperty.call(
    query,
    "region"
  );
  const hasLegacyMethodQuery = Object.prototype.hasOwnProperty.call(
    query,
    "method"
  );

  if (currentPath !== path || hasLegacyRegionQuery || hasLegacyMethodQuery) {
    return {
      path,
      query: nextQuery,
    };
  }

  return null;
}
